/**
 * Main App component with routing
 */

import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { LandingPage } from './pages/LandingPage';
import { UploadPage } from './pages/UploadPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ResultsPage } from './pages/ResultsPage';
import { UsersPage } from './pages/UsersPage';
import { QVTPrimerPage } from './pages/QVTPrimerPage';
import { Toaster } from './components/ui/toaster';

export default function App() {
  return (
    <>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<LandingPage />} />

        {/* Protected routes - all users */}
        <Route
          path="/upload"
          element={
            <ProtectedRoute>
              <UploadPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/qvt-primer"
          element={
            <ProtectedRoute>
              <QVTPrimerPage />
            </ProtectedRoute>
          }
        />

        {/* Protected routes - admin only */}
        <Route
          path="/projects"
          element={
            <ProtectedRoute requireAdmin>
              <ProjectsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/results/:id?"
          element={
            <ProtectedRoute requireAdmin>
              <ResultsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute requireAdmin>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        {/* Fallback - redirect to landing */}
        <Route path="*" element={<LandingPage />} />
      </Routes>
      <Toaster />
    </>
  );
}
